import { URL_LABEL } from "../../../../content/index.content";

const amazonTrainingsAndCourses = ({ language, isSavedUser }) => {
  return {
    title: "Amazon Trainings & Courses",
    subtitle:
      "Free workshops and courses from Amazon experts who will show you how to start a successful business on Amazon, step-by-step",
    href: `https://learn.amzscout.net/amazon-trainings?${URL_LABEL}`,
    // href: `/amazon-seller-training-courses/?${URL_LABEL}`,
    // isLink: true,
  };
};

export default amazonTrainingsAndCourses;
